$(document).ready(function(){

  // keep shopify close confirmation popup modle close code
  $(document).on('click', '.bcpo-modal-close', function(e){
    if( $('.tom_confirmation_popup').hasClass('is-visible') ){
      $('.tom_confirmation_popup').removeClass('is-visible');
      $('body').removeClass('tom_o_hidden');
      $('.tom_modal_atc_first_content').each(function() {
        $(this).find('video.myvideo').get(0).pause();
      });
    }
  });
  
  var $navBar = $('.header-wrapper');
  var navPos = $navBar.offset().top;
  $(window).on('scroll resize', function() {
    if($(window).width() > 767) {
      var scrollPos = $(this).scrollTop();
      if (scrollPos >= navPos) {
        $navBar.addClass('fixed');
      } else {
        $navBar.removeClass('fixed');
      }
    }else{
      stickybits(".section-header", { useStickyClasses: true });
      $navBar.removeClass('fixed');
    }
  });

  $('.tom_custom_atc_btn.modal-toggle').on('click', function(e) {
    e.preventDefault();
    $('.modal').toggleClass('is-visible');
    $('body').toggleClass('tom_o_hidden');
    $('.product_mobile_qa_video').removeClass('is-visible');
    $('.tom_modal_atc_first_content').each(function() {
      $(this).find('video.myvideo').get(0).play();
    });
  });
  $('.tom_confirmation_popup .modal-overlay, .modal-close').click(function(){
    $('.tom_confirmation_popup').removeClass('is-visible');
    $('body').removeClass('tom_o_hidden');
    $('.tom_modal_atc_first_content').each(function() {
      $(this).find('video.myvideo').get(0).pause();
    });
  });
  $(window).on("load resize", function(){     
    $('.tom_qa_dm_video span').on('click', function(e){
      //alert();
      e.preventDefault();
      $('.product_mobile_qa_video').addClass('is-visible');
      $('body').addClass('tom_o_hidden');
      $('.tom_modal_atc_first_content').each(function() {
        $(this).find('video.myvideo').get(0).play();
      });
    });
    $('.product_mobile_qa_video .modal-overlay').click(function(){
      $('.tom_confirmation_popup').removeClass('is-visible');
      $('.product_mobile_qa_video').removeClass('is-visible');
      $('body').removeClass('tom_o_hidden');
      $('.tom_modal_atc_first_content').each(function() {
        $(this).find('video.myvideo').get(0).pause();
      });
    });
    $('.tom_qa_dm_video video').trigger('pause');
  });
  $('.modal_button .tom_atc_btn button').click(function(){
    $('.modal').removeClass('is-visible');
    $('body').removeClass('tom_o_hidden');
    $('.tom_modal_atc_first_content').each(function() {
      $(this).find('video.myvideo').get(0).pause();
    });
  });

  var tom_announcebar = $(".flickity-slider .announcement-bar").length;
  if( tom_announcebar == 1){
    $(".new_announcement_bar .flickity-button").css("display", "none");
    $(".tom_annoucbar_count").css("display", "none");
  }else{
    $(".new_announcement_bar .flickity-button").css("display", "block");
  }
  if ($(window).width() < 767) {
    $('.tom_qa_dm_video video').trigger('pause');
  }
  
  $("ul.menu-drawer__menu summary.tom_mobile_inner_menu").click(function(){
    $(this).toggleClass('tm_arrow_show');
  });
  $('.toggle').click(function(e) {
    e.preventDefault();
    var $this = $(this);
    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.next().slideUp(350);
    } else {
      $this.parent().parent().find('li .inner').removeClass('show');
      $this.parent().parent().find('li .inner').slideUp(350);
      $this.next().toggleClass('show');
      $this.next().slideToggle(350);
    } 
  });
  $('ul.accordion > li a.first_tom_toggle').click(function(e) {
    $(this).parent().toggleClass("active");
    $(this).parent().siblings().removeClass("active");
    //$(this).parent().addClass("active").siblings().removeClass("active"); 
  }); 
  $('.toggle.tom_isi').click(function(){
    $(this).toggleClass("active");  
  }); 
  $('.search-modal__content .modal__close-button, .modal-overlay').click(function(){
    $('.header__search details').removeAttr('open');
  });
  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');
    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');
    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });
  $('ul.tabs li:first-child').addClass('current');
  $('.tom_tab_content .tab-content:first-child').addClass('current');

  var $gallery = new SimpleLightbox('#gallery a', {loadingTimeout: 50});
  
  var x_timer;  
  $(document).on('click','.search__button',function(e){
    $('.blog-loader').show();
    $('.pagination-wrapper').show();  
    //.preventDefault();
    clearTimeout(x_timer);
    var searchTitle = $('#blog_filter').val().toLowerCase().replace(/\s+/g, '-');
    var inputVal = $('#blog_filter').val();
    var currentUrl = $('#blog_filter').attr('data-url');
    var FinalUrl = currentUrl;
    //console.log('FinalUrl--',FinalUrl);
      
    x_timer = setTimeout(function(){
      $.ajax({ 
        type: "GET",  
        dataType: "html",
        url: FinalUrl,
        async: false,
        success : function(data){
         
          if(inputVal.length > 1){
            var updatedHtml = $(data).find('#blog-articles_search').html();
            $('#blog-articles').html(updatedHtml);
             //console.log('updatedHtml---',updatedHtml);
            var search_val =  inputVal.toLowerCase();
            //console.log("search_val", search_val);
            $('#blog-articles .article-item').each(function(){
              // || $(this).find('.tom_article_short_description p').text().toLowerCase().search(search_val) > -1
              if ($(this).find('.card__heading a').text().toLowerCase().search(search_val) > -1 || $(this).find('.tom_articles_tags span').text().toLowerCase().search(search_val) > -1 ) {
                // console.log("123");
                $(this).show();
                $(this).addClass('is-active');
              } else {
                $(this).hide();
                $(this).removeClass('is-active');
                // console.log("456");
              }
            });
            setTimeout(function(){
              if($('#blog-articles .article-item.is-active').length > 0){
                $('.no-results.model-no-results').hide();
                $('.load-more_wrap').show();
                $('.pagination-wrapper').show();  
              }else{
                $('.no-results.model-no-results').show();
                $('.load-more_wrap').hide();
                $('.pagination-wrapper').hide();  
              }
              $('.blog-loader').hide();
              $('.pagination-wrapper').hide();
            },1000);
          }else{
            var updatedHtml = $(data).find('#blog-articles').html();
            $('#blog-articles').html(updatedHtml);
            setTimeout(function(){
            },1000);
            $('.blog-loader').hide();
          }
        }
      });   
    }, 1000);
  });  
  $('.js-load-more').on('click', function() {
    var $this = $(this),
        totalPages = parseInt($('[data-all-pages]').val()),
        currentPage = parseInt($('[data-this-page]').val()),
        datacollurl = $('[data-coll-url]').val();
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hidden');
    $this.find('[loader]').removeClass('hidden');
    var nextUrl = $('[data-next-link]').val();
    var current_page_new = currentPage + 1;
    var next_coll = currentPage + 2;
    //alert(current_page_new)
    //return false;
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML) {
        $('[data-next-link]').val(datacollurl + "?page=" + next_coll);
        $('[data-this-page]').val(current_page_new);
        $('.blog-articles').append($(responseHTML).find('.blog-articles').html());
      },
      complete: function() {
        if (current_page_new < totalPages) {
          $this.attr('disabled', false);
          $this.find('[load-more-text]').removeClass('hidden');
          $this.find('[loader]').addClass('hidden');
        }
        if (current_page_new >= totalPages) {
          $this.find('[load-more-text]').text('Articles Finished').removeClass('hidden');
          $this.find('[loader]').addClass('hidden');
        }
      }
    });
  });
  $('.brick.content a').click(function(){
    $('body').addClass('o-hidden');
  });
  if($('sticky-header').hasClass('color-w-background')){
    $('.slideshow-component').addClass('bg_white_slide_than_mt_in_slide');  
  }
  $('.embed-etranslate-language-list-button').click(function(){
    $('.embed-etranslate-language-list-dropdown-box').toggleClass("show_laung");
    $('.embed-etranslate-language-arrow').toggleClass("tom_lang_angle");
  });
  $(document).on("click", function(event){
    var $trigger = $(".embed-etranslate-language-list-button");
    if($trigger !== event.target && !$trigger.has(event.target).length){
      $('.embed-etranslate-language-list-dropdown-box').removeClass('show_laung');
      $('.embed-etranslate-language-arrow').removeClass("tom_lang_angle");
    }      
  });
  $('#Details-HeaderMenu-3').children('.mega-menu__content').find("h2").text('3D Creators');
  var video = $('.video-section__media').children('iframe');
});